import { Plugin } from 'ckeditor5/src/core';
import { FileRepository } from 'ckeditor5/src/upload';
import '../theme/fileuploadprogress.css';
export default class FileUploadProgress extends Plugin {
    constructor() {
        super(...arguments);
        this.uploadStatusChange = (evt, data, conversionApi) => {
            const editor = this.editor;
            const modelFile = data.item;
            const uploadId = modelFile.getAttribute('uploadId');
            if (!conversionApi.consumable.consume(data.item, evt.name) || !uploadId) {
                return;
            }
            const fileRepository = editor.plugins.get(FileRepository);
            const loader = fileRepository.loaders.get(uploadId);
            const status = uploadId ? data.attributeNewValue : null;
            const viewFile = editor.editing.mapper.toViewElement(modelFile);
            const viewWriter = conversionApi.writer;
            if (status == 'reading') {
                if (!viewFile.hasClass('ck-file-uploading')) {
                    viewWriter.addClass('ck-file-uploading', viewFile);
                }
                return;
            }
            if (loader && status === 'uploading') {
                _showProgressBar(viewFile, viewWriter, loader, editor.editing.view);
            }
            else if (status === 'complete') {
                const element = _getUIElement(viewFile, 'progressBar');
                if (element) {
                    viewWriter.remove(viewWriter.createRangeOn(element));
                }
                if (viewFile.hasClass('ck-file-uploading')) {
                    viewWriter.removeClass('ck-file-uploading', viewFile);
                }
            }
        };
    }
    static get pluginName() {
        return 'FileUploadProgress';
    }
    init() {
        const editor = this.editor;
        // Upload status change - update file's view according to that status.
        editor.editing.downcastDispatcher.on('attribute:uploadStatus:file', this.uploadStatusChange);
    }
}
function _getUIElement(viewFile, uniqueProperty) {
    for (const child of viewFile.getChildren()) {
        if (child.getCustomProperty(uniqueProperty)) {
            return child;
        }
    }
}
function _showProgressBar(viewFile, writer, loader, view) {
    const progressBar = writer.createUIElement('div', { class: 'ck-progress-bar' });
    writer.insert(writer.createPositionAt(viewFile, 'end'), progressBar);
    writer.setCustomProperty('progressBar', true, progressBar);
    // Update progress bar width when uploadedPercent is changed.
    loader.on('change:uploadedPercent', (evt, name, value) => {
        view.change(writer => {
            writer.setStyle('width', value - 1 + '%', progressBar);
        });
    });
}
